import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=35c32381"
import script from "./HomeView.vue?vue&type=script&scoped=true&lang=js"
export * from "./HomeView.vue?vue&type=script&scoped=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports